import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { useAuth } from "../context/AuthContext";
import { Container } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import { ButtonFormSubmit } from "./ButtonFormSubmit";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";

export const LoginForgotPassword = ({ pageHeaderMsg, close = null }) => {
  const { publicAxios } = useAuth();
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState(null);
  const [errMsg, setErrMsg] = useState(null);
  const [emailInvalid, setEmailInvalid] = useState(false);

  const onResetPassword = async (e) => {
    e.preventDefault();
    setEmailInvalid(false);
    if (email === null) {
      setEmailInvalid(true);
      setErrMsg("Please enter a valid email");
      return;
    }

    setLoading(true);
    try {
      await publicAxios().post("/auth/reset_password", null, {
        params: {
          email: email,
        },
      });

      pageHeaderMsg({
        className: "axis-message-header-success",
        msg: "Reset password email has been successfully sent",
      });
    } catch (error) {
      console.log(error);
      pageHeaderMsg({
        className: "axis-message-header-failure",
        msg: "Reset password email has not been set please try again.",
      });
    }
  };

  const handleEmail = async (e) => {
    e.preventDefault();
    setEmail(e.currentTarget.value);
  };

  const displaySubmitButtonSelection = () => {
    if (close !== null)
      return (
        <Modal.Footer className={"mb-0 pb-0"}>
          <Container fluid>
            <Row className="mb-3 justify-content-between, align-content-center">
              <Col>
                <ButtonFormSubmit
                  formOnSubmit={onResetPassword}
                  buttonText={"Send Email Request"}
                  disableButton={loading}
                />
              </Col>
              <Col>
                <Button
                  className={"w-100 h-100"}
                  onClick={close}
                  variant={"secondary"}
                >
                  Close
                </Button>
              </Col>
            </Row>
          </Container>
        </Modal.Footer>
      );

    return (
      <ButtonFormSubmit
        formOnSubmit={onResetPassword}
        buttonText={"Reset"}
        disableButton={loading}
      />
    );
  };

  return (
    <Container fluid>
      <h2 className={"h1 m-0 p-0 fw-bold text-axis-offblack"}>
        Reset Your Password.
      </h2>
      <p className={"m-0 p-0 mb-5 text-axis-offblack"}>
        Enter your email below and we will send you a password reset email.
      </p>
      <Form noValidate onSubmit={onResetPassword} className={"m-0 p-0"}>
        <Form.Group
          as={Row}
          controlId="formBasicEmail"
          className={"m-0 p-0 mb-5"}
        >
          <Form.Label className={"m-0 p-0 mb-1 text-axis-offblack"}>
            Email address
          </Form.Label>
          <Form.Control
            type={"email"}
            placeholder={"name@email.com"}
            required
            onChange={handleEmail}
            isInvalid={emailInvalid}
          />
          <Form.Control.Feedback className={"p-0 m-0 mb-2"} type={"invalid"}>
            {errMsg}
          </Form.Control.Feedback>
        </Form.Group>
      </Form>
      {displaySubmitButtonSelection()}
    </Container>
  );
};
